import clsx from "clsx";
import type { FC } from "react";

import type { BlockType } from "../../../shared/types/worksheet";
import { BLOCK_TYPE_TO_ICON } from "../AddElement";

import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { IconText } from "mds/components/IconText";

type BlockResponsesHeaderProps = {
  blockType: BlockType["t"];
  doneCount: number;
  totalCount: number;
  sticky?: boolean;
  titleOnly?: boolean;
};

export const BlockResponsesHeader: FC<BlockResponsesHeaderProps> = ({
  blockType,
  titleOnly,
  doneCount,
  totalCount,
  sticky = true,
}) => {
  const Icon = BLOCK_TYPE_TO_ICON[blockType];

  const title = t(`fields.headers.${blockType}`);
  const progressText = t("presentation_aggregates.made_progress", {
    doneCount,
    count: totalCount,
  });

  const text = titleOnly ? title : `${title}: ${progressText}`;

  // The extra div is a bit of a CSS hack to get padding to appear below the sticky header.
  return (
    <div className={clsx("top-0 z-10 flex flex-col bg-white", sticky && "sticky")}>
      <Card className="body-s-bold page-block-width mx-auto" kind="blue">
        <IconText iconStart={<Icon />} text={text} />
      </Card>
      <div className="h-[16px] w-full" />
    </div>
  );
};
